import {API_URL} from "../settings/local_settings";
import {APIClient} from "./APIClient";

export class AccessService {
    static MODULE_MARKETING = "MARKETING";
    static MODULE_MANAGE_ACCOUNTS = "MANAGE_ACCOUNTS";
    static MODULE_TEAM = "TEAM";
    static MODULE_SHEETS_SYNC = "SHEETS_SYNC";
    static MODULE_DATA_EXPLORER = "DATA_EXPLORER";
    static MODULE_AGENT = "AGENT";
    static MODULE_REPORTS = "REPORTS";
    static MODULE_ACCESS_CONFIGURATION = "ACCESS_CONFIGURATION"
    static MODULE_INSIGHTS = "INSIGHTS"
    static MODULE_ACTIVITY_LOG = "ACTIVITY_LOG"
    static MODULE_DASHBO_MCP = "DASHBO_MCP"
    static MODULE_CLIENT_CONNECTIONS = "CLIENT_CONNECTIONS"
    static MODULE_CLIENT_MEMORY = "CLIENT_MEMORY"

    // Niveles de acceso a la Memoria del Cliente (los resuelve el backend por allowlist de agencia y
    // los devuelve en GetUserModules como `client_memory_level`). OFF = sin Memoria; MEDIO = subir
    // docs + resumen/crudo, sin Hechos; TOTAL = pipeline completo de Hechos.
    static MEMORY_LEVEL_OFF = "OFF"
    static MEMORY_LEVEL_MEDIO = "MEDIO"
    static MEMORY_LEVEL_TOTAL = "TOTAL"

    static GetUserModulesUrl(userId) {
        return API_URL + `user/${userId}/access/modules`;
    }

    static GetUserModules(userId, handlerOnSuccess, handlerOnError=null) {
        new APIClient(AccessService.GetUserModulesUrl(userId)).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                if(handlerOnError)
                    handlerOnError(data);
                else
                    alert(data['error_message']);
            } else if (data.status === 'OK') {
                handlerOnSuccess(data.data)
            }
        })
    }
}
